import { USER_KEY } from './reducers';

export function getUser(state) {
    return state.get(USER_KEY);
}

export function getAvailableSessionTypes(state) {
    return state.getIn([USER_KEY, 'availableSessionTypes']);
}

export function getStudentName(state) {
    const user = getUser(state);
    if (!user) {
        return null;
    }

    return user.get('firstName') + ' ' + user.get('lastName');
}

export function getStudentFirstName(state) {
    const user = getUser(state);
    if (!user) {
        return null;
    }

    return user.get('firstName');
}

export function getStudentLastName(state) {
    const user = getUser(state);
    if (!user) {
        return null;
    }

    return user.get('lastName');
}

export function getStudentID(state) {
    const user = getUser(state);
    if (!user) {
        return null;
    }

    return user.get('id');
}

export function getIsPrimaryStudent(state) {
    const user = getUser(state);
    if (!user) {
        return null;
    }

    return user.get('isPrimaryStudent');
}

/**
 * Selector for determining whether the current user is a staff user - i.e. a teacher logging in
 * as a student with their staff account
 * @param state the root Redux state
 * @return {boolean}
 */
export function getIsStaffUser(state) {
    const user = getUser(state);
    return user ? user.get('isStaffUser') : false;
}
